import { createFileRoute } from '@tanstack/react-router';
import { CasinoProvidersPage } from '@/ui/casino';

export const Route = createFileRoute('/casino/providers')({
  component: CasinoProvidersPage,
});
